import '../assets-base/assets-src/scss/bootstrap.scss';
import '../assets-base/assets-src/scss/fontawesome.scss';
import '../assets-base/assets-src/scss/spinao.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import BSCustomFileInput from '../assets-base/assets-src/js/bootstrap/CustomFileUpload/index';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as BackToTop from '../assets-base/assets-src/js/Spinao/BackToTop';
import * as EUCookie from '../assets-base/assets-src/js/Spinao/EUCookie';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as GoogleReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';

document.addEventListener("DOMContentLoaded", function() {
    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    UnifyHeight.applyTo('.js-unify-height');

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');

    BSCustomFileInput.init();

    GoogleMaps.initialize();
    GoogleReCaptcha.initialize();
});
